/**
    Form Encode Types
    @readonly
    @enum {string}
*/
export var FORMENCTYPE;
(function (FORMENCTYPE) {
    FORMENCTYPE["URLENCODED"] = "application/x-www-form-urlencoded";
    FORMENCTYPE["MULTIPART"] = "multipart/form-data";
    FORMENCTYPE["TEXT"] = "text/plain";
})(FORMENCTYPE || (FORMENCTYPE = {}));
;
